import { Component } from '@angular/core';
import { MenuController, NavController, AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { App } from '@capacitor/app';
import { StoresService } from './core/services/stores/stores.service';
import { Platform } from '@ionic/angular';
import { OrdersService } from './core/services/orders/orders.service';
import { Router } from '@angular/router';
import { SoundService } from './core/services/sound/sound.service';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  storeStatus: boolean;
  timer = 0;
  storeId;

  private destroyed$ = new Subject();

  titleEcommerce: string;
  ecommerceName: string;
  branchOffice: string;

  constructor(public menu: MenuController, private storage: Storage, private platform: Platform,
    private navController: NavController, private ordersService: OrdersService,
    private storesService: StoresService, private alertController: AlertController,
    private router: Router, private translateService: TranslateService, private soundService: SoundService) {
    // Idioma
    this.translateService.setDefaultLang('es');
    this.translateService.use('es');
  }

  ngOnInit() {
    this.ecommerceName = environment.ecommerceName;
    this.titleEcommerce = environment.titleEcommerce;
    App.addListener("backButton", () => {
      let data = {
        status: "PAID"
      }

      if (window.confirm("¿Está seguro que desea salir?")) {
        if (localStorage.getItem('orderInCheck') != undefined) {
          this.ordersService.getOrderById(localStorage.getItem('orderInCheck')).subscribe(order => {
            if (order.status == "CHECKING") {
              this.ordersService.updateOrderStatusById(localStorage.getItem('orderInCheck'), data).subscribe(order => {
                localStorage.removeItem('orderInCheck');
                App.exitApp();
              });
            } else {
              localStorage.removeItem('orderInCheck');
              App.exitApp();
            }
          });
        } else {
          App.exitApp();
        }
      }
      else if (localStorage.getItem('orderInCheck') != undefined) {
        this.ordersService.getOrderById(localStorage.getItem('orderInCheck')).subscribe(order => {
          if (order.status == "CHECKING") {
            this.ordersService.updateOrderStatusById(localStorage.getItem('orderInCheck'), data).subscribe(order => {
              this.getOrders();
            });
          } else {
            this.getOrders();
          }
        });
      }
    })

    App.addListener("appStateChange", ({ isActive }) => {
      if (!isActive && localStorage.getItem('isUserLoggedIn') == 'true') {
        this.timer = 1;
        this.destroyed$ = new Subject();
        timer(30000, 300000)
          .pipe(takeUntil(this.destroyed$))
          .subscribe(() => {
            this.soundService.playSoundAlert();
          });
      } else {
        if (this.timer == 1) {
          this.destroyed$.next();
          this.destroyed$.complete();
          this.timer = 0;
        }
      }
    })

    if (localStorage.getItem('storeStatus') == 'true') {
      this.storeStatus = true;
    } else {
      this.storeStatus = false;
    }
    this.storeId = localStorage.getItem('storeId');
    if (localStorage.getItem('isUserLoggedIn') == 'true') {
      this.storesService.getShedule(localStorage.getItem('storeId'), new Date().getDay()).subscribe(store => {
        let shedule = { "date": new Date(), "open": store[0].open, "close": store[0].close };
        localStorage.setItem('shedule', JSON.stringify(shedule));
      });
      this.router.navigate(['/home/new-orders']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  getOrders() {
    let storeId = localStorage.getItem('storeId');
    this.ordersService.getPaidOrdersByStore(storeId).subscribe(orders => {
      orders = orders.filter(order => order.comeFromSystem !== 'YUMMY' && order.comeFromSystem !== 'BACKOFFICE' && order.comeFromSystem !== 'COURTESY');
      orders.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt === b.createdAt ? 0 : -1);

      for (let order of orders) {
        order.createdAt = new Date(new Date(order.createdAt.substring(0, 4) + "-" + order.createdAt.substring(5, 7) + "-" + order.createdAt.substring(8, 10) + " " + order.createdAt.substring(11, 13) + ":" + order.createdAt.substring(14, 19)).getTime());
      }
    });
  }

  async changeStatus() {
    this.branchOffice = localStorage.getItem('branchOffice');
    let message;
    let status;
    let header;
    let cssClass;
    if (this.storeStatus) {
      message = 'La sucursal tiene un horario de apertura/cierre automatizado.<br><br>Este botón se usa para desactivar una sucursal por situación fuera de lo normal (no hay luz, no hay internet, etc).<br><br>¿Está seguro que desea DESACTIVAR la sucursal "' + this.branchOffice + '"?'
      status = 'false';
      header = 'Desactivar Sucursal';
      cssClass = 'custom-alert-desactivate';
    } else {
      message = '¿Está seguro que desea ACTIVAR la sucursal "' + this.branchOffice + '"?'
      header = 'Activar Sucursal';
      status = 'true';
      cssClass = 'custom-alert';
    }

    const alert = await this.alertController.create({
      header: header,
      message: message,
      cssClass: cssClass,
      buttons: [
        {
          text: 'No',
          cssClass: 'alert-button-cancel'
        },
        {
          text: 'Sí',
          cssClass: 'alert-button-confirm',
          handler: () => {
            localStorage.setItem('storeStatus', status);
            this.storeStatus = !this.storeStatus;
            let storeStatus = { status: this.storeStatus };
            this.storesService.updateStore(localStorage.getItem('storeId'), storeStatus).subscribe(data => {
            });
          }
        }
      ]
    });
    this.storeStatus = !this.storeStatus;

    await alert.present();

  }

  logout() {
    localStorage.removeItem('userId');
    localStorage.removeItem('storeId');
    localStorage.removeItem('account');
    localStorage.removeItem('storeStatus');
    localStorage.removeItem('branchOffice');
    localStorage.removeItem('branchOfficeAddress');
    localStorage.removeItem('shedule');
    localStorage.removeItem('token');
    this.menu.enable(false, 'first');
    localStorage.removeItem('isUserLoggedIn');
  }

  refreshStatus() {
    this.branchOffice = localStorage.getItem('branchOffice');
    // Siempre actualiza el storeId antes de refrescar
    this.storeId = localStorage.getItem('storeId');
    this.storesService.getStore().subscribe(stores => {
      // Soporta respuesta como array u objeto
      let storesArray = Array.isArray(stores) ? stores : [stores];
      for (let store of storesArray) {
        if (String(store.id) === String(this.storeId)) {
          // Normaliza a booleano
          this.storeStatus = (store.status === true || store.status === 'true');
          localStorage.setItem('storeStatus', String(this.storeStatus));
          // Forzar la detección de cambios si es necesario
          if (typeof (window as any).ng !== 'undefined') {
            // Solo si Angular está disponible globalmente
            (window as any).ng.getInjector(this).get((window as any).ng.coreTokens.ChangeDetectorRef).detectChanges();
          }
        }
      }
    });
  }

  closeMenu() {
    this.menu.close();
  }
}
